<template>
  <div class="change-avatar">
    <CropperAvatar
      ref="cropperRef"
      :btnProps="{ preIcon: 'ant-design:cloud-upload-outlined' }"
      :showBtn="false"
      :value="img"
      width="120px"
      @change="handelUpload"
    />
  </div>
</template>
<script lang="ts" setup>
import { propTypes } from '@/utils/propTypes'
import { updateUserProfile } from '@/api/system/user/profile'
import { CropperAvatar } from '@/components/Cropper'
import { useUserStore } from '@/store/modules/user'
import { useUpload } from '@/components/UploadFile/src/useUpload'
import { UploadRequestOptions } from 'element-plus/es/components/upload/src/upload'

defineOptions({ name: 'UserAvatar' })

defineProps({
  img: propTypes.string.def('')
})

const userStore = useUserStore()
const message = useMessage()

const cropperRef = ref()
/** 裁剪结果是新像素 → 必须 FileApi 登记（计配额）；选库只解决「底图来源」 */
const handelUpload = async ({ data, filename }: { data: Blob; filename?: string }) => {
  try {
    const { httpRequest } = useUpload('avatar')
    const file = new File([data], filename || 'avatar.png', { type: (data as any).type || 'image/png' })
    const res = (await httpRequest({
      file,
      filename: file.name
    } as UploadRequestOptions)) as unknown as { data: string }
    const avatar = typeof res === 'string' ? res : (res as any)?.data
    if (!avatar) {
      message.error('头像上传失败')
      return
    }
    await updateUserProfile({ avatar })
    cropperRef.value.close()
    await userStore.setUserAvatarAction(avatar)
  } catch (e: any) {
    message.error(e?.message || e?.msg || '头像上传失败')
  }
}
</script>

<style lang="scss" scoped>
.change-avatar {
  img {
    display: block;
    margin-bottom: 15px;
    border-radius: 50%;
  }
}
</style>
